<template>
  <div>
    <basic-notice-list v-if="!isLaunchpack"></basic-notice-list>

    <launchpack-notice-list v-if="isLaunchpack"></launchpack-notice-list>
  </div>
</template>

<script>
  import BasicNoticeList from "./BasicNoticeList";
  import LaunchpackNoticeList from "./LaunchpackNoticeList";

  export default {
    name: 'NoticeList',
    components: {
      LaunchpackNoticeList,
      BasicNoticeList
    },
    created() {

    },
    data() {
      return {}
    },
    methods: {

    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main';

</style>
